module.exports = __webpack_public_path__ + "img/蓝-选中@3x.1cafde47.png";